import { createAction } from 'redux-actions';
import { identity, isArray } from 'lodash';
import { SubmissionError } from 'redux-form';
import { nanoid } from 'nanoid';
import { handleErrorResponseData } from './helpers';
import { actions as notifications } from 'modules/notifications';
import { unflatten } from 'flat';
export const PREFIX = '@@shelf';
export const statuses = ['START', 'SUCCESS', 'ERROR'];

const getType =
  (status: string) =>
  (name): string =>
    `${PREFIX}/${status} -> ${name.toString()}`;

const createApiAction = (name, status) =>
  createAction(getType(status)(name), identity, (_, request) => ({
    name,
    status,
    request,
    time: new Date().getTime(),
  }));

const defaultMapper = (data) =>
  isArray(data) ? { entities: data } : { entity: data };

const metaMapper = (_, request) => request;
const getFormErrors = (error) =>
  (error.fields &&
    unflatten(
      error.fields.reduce((acc, f) => ({ ...acc, [f.field]: f.message }), {
        _error: error.error && error.error.message,
      })
    )) ||
  (error.message && { _error: error.message });

export const create = (
  actionName,
  apiFunction,
  responseMapper = defaultMapper
) => {
  const _name = `[${nanoid(3)}]${actionName}`;
  const action = createAction(_name, responseMapper, metaMapper);
  const [start, success, error] = statuses.map((status) =>
    createApiAction(_name, status)
  );
  const apiAction =
    (...params) =>
    (dispatch) => {
      dispatch(start());
      return apiFunction(...params)
        .then(({ data, ...rest }) => {
          dispatch(success(data, ...params));
          dispatch(action(data, ...params));
          return data;
        })
        .catch((e) => {
          const res = handleErrorResponseData(e);
          if (!res) throw e;
          const _error = getFormErrors(res.fields ? res : res.error || res);
          dispatch(error(e.response, ...params));
          if (_error) {
            if (_error._error)
              dispatch(
                notifications.create({ text: _error._error, type: 'warning' })
              );
            throw new SubmissionError(_error);
          }
        });
    };

  apiAction.toString = (): string => _name;
  return apiAction;
};

export const success = getType(statuses[1]);
export const error = getType(statuses[2]);
